import { useEffect, useState } from "react";
import { qrToPngDataUrl } from "../lib/qrPng";

interface QrPngProps {
  text: string;
  className?: string;
  "aria-label"?: string;
}

export function QrPng({ text, className, "aria-label": ariaLabel }: QrPngProps) {
  const [png, setPng] = useState<string>("");

  useEffect(() => {
    let active = true;
    if (!text) {
      setPng("");
      return;
    }
    qrToPngDataUrl(text)
      .then((url) => {
        if (active) setPng(url);
      })
      .catch(() => {
        if (active) setPng("");
      });
    return () => {
      active = false;
    };
  }, [text]);

  if (!png) return <div data-testid="qr-png" aria-label={ariaLabel ?? "QR"} style={{ width: "100%", height: "100%" }} />;
  return (
    <img
      className={className}
      data-testid="qr-png"
      aria-label={ariaLabel ?? (text ? `QR ${text}` : "QR")}
      src={png}
      alt=""
      style={{ width: "100%", height: "100%", display: "block", imageRendering: "pixelated" }}
    />
  );
}
